import { OrderItemFormProvider } from "./OrderItemFormProvider";
import { BarcodeFormInput } from "./components/BarcodeFormInput";
import { NameFormInput } from "./components/NameFormInput";
import { QuantityFormInput } from "./components/QuantityFormInput/QuantityFormInput";
import { SupplierCodeFormInput } from "./components/SupplierCodeFormInput";

export interface OrderItemFormProps {}

export const OrderItemForm = ({}: OrderItemFormProps) => {
  return null;
};

OrderItemForm.QuantityFormInput = QuantityFormInput;
OrderItemForm.Provider = OrderItemFormProvider;
OrderItemForm.SupplierCodeFormInput = SupplierCodeFormInput;
OrderItemForm.BarcodeFormInput = BarcodeFormInput;
OrderItemForm.NameFormInput = NameFormInput;
